import {Logger} from '#core/utils/logger.js';
import {deepFreezeAllEnumerables} from '#core/utils/config-utils.js';

import {PaletteRetriever} from '#core/application/modules/palette-retriever.js';

import {registerPaletteSchema} from '../schema-registry.js';

import BASIC_PALETTE_SCHEMA from './basic.palette-schema.yaml';

const log = Logger('BasicPalette');

export const BasicPalette = {
    palette: {},

    load: function (config) {
        this.migrateConfig(config);

        let validator = new PaletteRetriever(log);
        validator.constructPaletteBySchema(config, BASIC_PALETTE_SCHEMA);
        this.palette = validator.intermediateCache; // not resulted palette, but with dark/light colors
        process.env.NODE_ENV === 'development' && deepFreezeAllEnumerables(this.palette);
    },

    migrateConfig(config) {
        const migrationMap = {
            DEFAULT_PAGE_BG: 'FILL_PAGE',
            DEFAULT_HEADER_BG: 'FILL_HEADER',
            DEFAULT_STYLIZED_BG: 'FILL_HERO',
            DEFAULT_SHEET_BG: 'FILL_SHEET',
            DEFAULT_POPOVER_BG: 'FILL_POPOVER',
            DEFAULT_PROMO_CARD_BG: 'FILL_CARD',
            DEFAULT_CONTROLS_BORDER_COLOR: 'FILL_CONTROL_OUTLINE',
            DEFAULT_ODDS_BG: 'FILL_CONTROL_ODDS',
            DEFAULT_ODDS_SELECTED_BG: 'FILL_SELECTED_ODDS',
            DEFAULT_SELECTION_BG: 'FILL_SELECTED_PRIMARY',
            DEFAULT_PRIMARY_BUTTON_COLOR: 'FILL_ACCENT_PRIMARY',
            DEFAULT_LIVE_COLOR: 'TEXT_ACCENT_FILL',
        };
        for (const [oldKey, newKey] of Object.entries(migrationMap)) {
            if (config[oldKey]) {
                config[newKey] = config[oldKey];
                delete config[oldKey];
            }
        }
    },
};

registerPaletteSchema(BASIC_PALETTE_SCHEMA);
